import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import { IMessage, IAnswerRequest, IMessageResponse } from "app/api/types";
import {
  getMessages,
  addAnswer,
  delMessage
} from "app/api/redux/Messages/actions";
import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";
import MessageList from "app/components/MessageList";

interface IProps extends RouteComponentProps<{ page: string }> {
  messageList: IMessage[];
  isLoading: boolean;
  count: number;
  limit: number;
  page: number;
  getMessages: (page: number) => Promise<IMessageResponse>;
  addAnswer: (data: IAnswerRequest) => Promise<AxiosResponse>;
  delMessage: (id: number) => Promise<AxiosResponse>;
}

class MessagesPage extends React.Component<IProps> {
  componentDidMount() {
    const { page } = this.props.match.params;

    this.props.getMessages(Number(page)).catch(err => {
      console.log(err);
      this.props.history.push("/404");
    });
  }

  componentDidUpdate(prevProps: IProps) {
    const { page } = this.props.match.params;
    if (prevProps.page !== Number(page)) {
      this.props.getMessages(Number(page)).catch(err => {
        console.log(err);
        this.props.history.push("/404");
      });
    }
  }

  render() {
    return (
      <LayoutUser>
        <MessageList
          messageList={this.props.messageList}
          isLoading={this.props.isLoading}
          addAnswer={this.props.addAnswer}
          getMessages={this.props.getMessages}
          delMessage={this.props.delMessage}
          page={this.props.page}
          limit={this.props.limit}
          count={this.props.count}
        />
      </LayoutUser>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    messageList: state.messages.messageList,
    count: state.messages.count,
    limit: state.messages.limit,
    page: state.messages.page,
    isLoading: state.masters.isLoading
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getMessages,
    addAnswer,
    delMessage
  })(MessagesPage)
);
